export default __webpack_public_path__ + "static/media/pngegg.ba92ef05.png";